import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import LockIcon from '@material-ui/icons/Lock';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import { useSensitiveInfoInputContext } from '../../../../Context';

const styles = () => ({
  root: {},
});

const LockedInputAdornment = ({
  className,
  classes,
  color,
  ariaLabel,
}) => {
  const { fetchSensitiveInfoCollection } = useSensitiveInfoInputContext();

  return (
    <InputAdornment position="end">
      <IconButton
        className={classNames(className, classes.root)}
        icon={LockIcon}
        aria-label={ariaLabel}
        title={'Reveal'}
        onClick={fetchSensitiveInfoCollection}
        onMouseDown={(event) => event.preventDefault()}
        color={color}
      />
    </InputAdornment>
  );
};

LockedInputAdornment.defaultProps = {
  className: '',
  color: 'primary',
  ariaLabel: 'Reveal field',
};

LockedInputAdornment.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  color: PropTypes.string,
  ariaLabel: PropTypes.string,
};

export default withStyles(styles)(LockedInputAdornment);
